(() => {
  const root = document.querySelector('[data-nnr]');
  if (!root) return;
  // Lien « avis / photos » du haut de fiche : on corrige la position après le chargement des blocs en différé
  document.addEventListener('click', e => {
    const a = e.target.closest('a[href="#nn-reviews"]');
    if (!a) return;
    e.preventDefault();
    const go = () => window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' });
    go(); setTimeout(go, 700); setTimeout(go, 1500);
    history.replaceState(null, '', '#nn-reviews');
  });
  const list = root.querySelector('[data-list]') || document.createElement('ol');
  const cards = [...list.querySelectorAll('.nnr__card')];
  const more = root.querySelector('[data-more]');
  const PAGE = 6;
  let shown = PAGE, filter = 'all';
  const data = Object.fromEntries(cards.map(c => {
    try { return [c.dataset.id, JSON.parse(c.querySelector('[data-review]').textContent)]; } catch (e) { return [c.dataset.id, null]; }
  }));

  function render() {
    const match = cards.filter(c => filter === 'all' || (filter === 'photos' ? +c.dataset.photos > 0 : c.dataset.rating === filter));
    cards.forEach(c => { c.hidden = true; });
    match.forEach((c, i) => { c.hidden = i >= shown; });
    if (more) more.hidden = match.length <= shown;
  }
  function sortBy(mode) {
    const by = {
      recent: (a, b) => b.dataset.date.localeCompare(a.dataset.date),
      photos: (a, b) => (+b.dataset.photos - +a.dataset.photos) || b.dataset.date.localeCompare(a.dataset.date),
      high: (a, b) => (+b.dataset.rating - +a.dataset.rating) || b.dataset.date.localeCompare(a.dataset.date),
      low: (a, b) => (+a.dataset.rating - +b.dataset.rating) || b.dataset.date.localeCompare(a.dataset.date)
    }[mode];
    cards.sort(by).forEach(c => list.appendChild(c));
    render();
  }
  root.querySelectorAll('[data-filter]').forEach(btn => btn.addEventListener('click', () => {
    filter = btn.dataset.filter; shown = PAGE;
    root.querySelectorAll('.nnr__chip').forEach(ch => ch.classList.toggle('is-active', ch.dataset.filter === filter));
    render();
    if (btn.classList.contains('nnr__bar')) list.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  const sel = root.querySelector('[data-sort]');
  if (sel) sel.addEventListener('change', () => sortBy(sel.value));
  if (more) more.addEventListener('click', () => { shown += PAGE; render(); });

  // Galerie plein écran
  const lb = root.querySelector('[data-lightbox]');
  const img = lb.querySelector('[data-lb-img]');
  const txt = lb.querySelector('[data-lb-text]');
  const prev = lb.querySelector('[data-prev]'), next = lb.querySelector('[data-next]');
  const flat = [];
  cards.forEach(c => { const r = data[c.dataset.id]; if (r && r.photos) r.photos.forEach((p, i) => flat.push({ id: c.dataset.id, i, src: p })); });
  root.querySelectorAll('[data-cp]').forEach(b => flat.push({ cp: +b.dataset.cp, src: b.dataset.src }));
  let pos = 0;
  const esc = s => String(s || '').replace(/[&<>"]/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]));
  function show(k) {
    pos = (k + flat.length) % flat.length;
    const f = flat[pos];
    img.src = f.src + (f.src.includes('?') ? '&' : '?') + 'width=1400';
    prev.hidden = next.hidden = flat.length < 2;
    if (f.cp !== undefined) {
      img.alt = 'Photo shared by a Nothenorm customer';
      txt.innerHTML = '<p class="nnr__label" style="margin:0">Customer photo</p><p class="nnr__body">Shared by a Nothenorm customer, wearing the piece.</p>';
      return;
    }
    const r = data[f.id];
    img.alt = 'Photo from ' + (r.author || 'a customer');
    const stars = '★★★★★'.slice(0, r.rating) + '<span style="opacity:.2">' + '★★★★★'.slice(r.rating) + '</span>';
    txt.innerHTML = `<div style="font-size:1.8rem;letter-spacing:.08em">${stars}</div>` +
      (r.title ? `<p class="nnr__card-title">${esc(r.title)}</p>` : '') +
      `<p class="nnr__body">${esc(r.body)}</p>` +
      `<p class="nnr__meta"><span class="nnr__author">${esc(r.author)}</span>${r.verified ? '<span class="nnr__verified">Verified buyer</span>' : ''}${r.country ? `<span class="nnr__country">${esc(r.country)}</span>` : ''}</p>` +
      (r.size ? `<p class="nnr__size">Size purchased: <strong>${esc(r.size)}</strong></p>` : '');
    prev.hidden = next.hidden = flat.length < 2;
  }
  root.querySelectorAll('[data-open], [data-cp]').forEach(b => b.addEventListener('click', () => {
    const k = b.dataset.cp !== undefined ? flat.findIndex(f => f.cp === +b.dataset.cp) : flat.findIndex(f => f.id === b.dataset.open && f.i === +b.dataset.photo);
    show(k < 0 ? 0 : k);
    lb.showModal();
  }));
  prev.addEventListener('click', () => show(pos - 1));
  next.addEventListener('click', () => show(pos + 1));
  lb.querySelector('[data-close]').addEventListener('click', () => lb.close());
  lb.addEventListener('click', e => { if (e.target === lb) lb.close(); });
  lb.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') show(pos - 1); if (e.key === 'ArrowRight') show(pos + 1); });

  if (cards.length) sortBy('recent');
})();
